import React, { useEffect, useMemo } from 'react';
import {
  Container,
  Copy,
  Flex,
  Section,
  Stack,
  StackSpace,
  SvgCaretLeft,
} from '@grubhubprod/gh-cookbook-react';
import { useParams } from 'react-router-dom';
import { GroupPeopleTable } from 'src/components/People/Groups/GroupPeopleTable';
import { useGetGroupData } from 'src/components/People/Groups/hooks/useGetGroupData';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { useAnalytics } from 'src/components/AnalyticsProvider/AnalyticsProvider';
import { RouterLink } from 'src/components/RouterLink/RouterLink';
import { GroupDetailsCard } from './GroupDetailsCard';

export const GroupDetails: React.FC = () => {
  const { isDesktop, isTablet } = useScreenSizes();

  const { sendTealiumPageView } = useAnalytics();

  function sendPageViewEvent() {
    sendTealiumPageView({
      pageGroup: 'corporate self service - account management',
      pageName: 'Grubhub | Self-Service Account | People | Group Details',
      subGroup: 'People Details > Group Details',
    });
  }

  useEffect(() => {
    sendPageViewEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { corpid: corpId, groupId } =
    useParams<{ corpid: string; groupId: string }>();

  const { data: groupData, refetch } = useGetGroupData(groupId, corpId);

  const shouldDisplayContent = !!(corpId && groupData);

  const stackSpacing = useMemo<StackSpace>(() => {
    if (isDesktop) return 'sm';
    if (isTablet) return 'md';
    return 'lg';
  }, [isDesktop, isTablet]);

  return (
    <Container variant="default">
      <Section inset="md">
        <Stack y={stackSpacing}>
          <Stack y="md">
            <Flex alignItems="center">
              <Copy variant="body" color="interactive">
                <SvgCaretLeft size="16px" />
              </Copy>
              <RouterLink
                href={`/corporate/management/${corpId}/people?tab=groups`}
              >
                Back to groups
              </RouterLink>
            </Flex>
          </Stack>

          {shouldDisplayContent && (
            <GroupDetailsCard
              corpId={corpId}
              groupData={groupData}
              onEditSuccess={refetch}
            />
          )}
        </Stack>

        {shouldDisplayContent && (
          <Stack>
            <GroupPeopleTable corpId={corpId} groupData={groupData} />
          </Stack>
        )}
      </Section>
    </Container>
  );
};
